module.exports = __webpack_public_path__ + "img/syukyaku-gyoumu-003.26f8d336.jpg";